// Mount-aware content fade - renders first frame at full opacity to avoid
// a white flash, then applies a subtle settle animation after first paint.
// Only wraps content inside PageWrapper, never the header or sidebar.
import React, { useEffect, useRef, useState } from "react";

const PageTransition = ({ children }) => {
  const [mounted, setMounted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Wait one frame so the first paint is at full opacity
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div
      ref={ref}
      className={mounted ? "page-settle" : ""}
      style={!mounted ? { opacity: 1 } : undefined}
    >
      {children}
    </div>
  );
};

export default PageTransition;
